export default __webpack_public_path__ + "static/media/mail.8ab6d94b.svg";